export const errorMessage = 'Something went wrong. Please try again.';
export const noDataMessage = 'No data. Something went wrong. Please try again.';
export const tobaccoEmptyDataTitle = 'Activate and submit scan data\nto view performance';
export const tobaccoEmptyDataDescription =
  'After you submit scan data through PAR Retail, this page will show performance\ntrends, member activity, offer redemptions, and estimated reimbursements.';
